import { render } from "./BidangDayasaing.vue?vue&type=template&id=63cbcf38"
import script from "./BidangDayasaing.vue?vue&type=script&lang=js"
export * from "./BidangDayasaing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__